import PageContainer from '@Guidelines/Layout/PageContainer';
import PageHeader from '@Guidelines/Layout/PageHeader';
import SubjectTypesNotifications from '@UI/Pages/Administration/SubjectTypes/Shared/SubjectTypesNotifications';
import NewSubjectTypeButton from '@UI/Pages/Administration/SubjectTypes/SubjectTypeList/NewSubjectTypeButton';
import SubjectTypeListContent from '@UI/Pages/Administration/SubjectTypes/SubjectTypeList/SubjectTypeListContent';
import type * as React from 'react';

const DESCRIPTION =
	"Le vocabulaire, la fiche et l'accès de chaque type de dossier. Le type Bénéficiaires est un type système.";

const SubjectTypeListPage: React.FC = () => {
	return (
		<PageContainer>
			<PageHeader
				eyebrow="CONFIGURATION"
				title="Types de dossier"
				description={DESCRIPTION}
				actions={<NewSubjectTypeButton />}
			/>
			<SubjectTypeListContent />
			<SubjectTypesNotifications />
		</PageContainer>
	);
};

export default SubjectTypeListPage;
